var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrochetEtCercleStatut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64c-8.549 0-16.583-3.328-22.629-9.371s-9.371-14.080-9.371-22.626c0-8.549 3.328-16.583 9.371-22.629s14.080-9.374 22.629-9.374c8.549 0 16.583 3.328 22.629 9.374s9.371 14.080 9.371 22.629c0 8.549-3.328 16.583-9.371 22.626s-14.080 9.371-22.629 9.371zM47.488 20.48c0.625-0.625 0.625-1.638 0-2.263s-1.638-0.625-2.263 0l-21.094 21.094-8.623-8.624c-0.625-0.625-1.638-0.625-2.263-0s-0.625 1.638 0 2.263l9.755 9.755c0.3 0.3 0.707 0.469 1.131 0.469s0.831-0.169 1.131-0.469l22.226-22.225z",
    fill: "#223654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrochetEtCercleStatut);
export default __webpack_public_path__ + "static/media/crochet-et-cercle-statut.c1e5c3e5fe8c54dab26857f45610dfa9.svg";
export { ForwardRef as ReactComponent };